import {ChangeDetectionStrategy, ChangeDetectorRef, Component,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormFieldConfig} from "../../../../model/api/form-field-config";
import {ClearingFlexService} from "../../../../services/clearing/flex/clearing-flex.service";
import {FlexTradesRequest} from "../../../../model/clearing/flex/flex-trades-request";
import {Owner} from "../../../../model/customer/owner";
import {Trade} from "../../../../model/clearing/trade";
import {CommonFieldService} from "../../../../services/common/common-field.service";
import {FlexTrade} from "../../../../model/clearing/flex/flex-trade";
import {MaturityUtils} from "../../../../utils/maturity-utils";
import {AppConfigService} from "../../../../services/app-config.service";
import {FlexFormDialogBaseComponent} from "../flex-form-dialog-base.component";
import {ClearingTradeInfoService} from "../../../../services/clearing/clearing-trade-info.service";
import TYPE = FormFieldConfig.TYPE;
import {Account} from "../../../../model/clearing/account";
import {DateFormatPipe} from "../../../../utils/date-format.pipe";
import {FieldsService} from "../../../../services/common/fields-service";
import {ClearingFlexTradeDataLoadingService} from "../../../../services/clearing/flex/clearing-flex-trade-data-loading.service";

@Component({
  selector: 'app-flex-edit-form-dialog',
  templateUrl: './flex-edit-form-dialog.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlexEditFormDialogComponent extends FlexFormDialogBaseComponent {

  formRecord: FlexTradesRequest = undefined;

  constructor(cdref: ChangeDetectorRef,
              clearingFlexService: ClearingFlexService,
              messageService: MessageService,
              configService: AppConfigService,
              clearingTradeInfoService: ClearingTradeInfoService,
              commonFieldService: CommonFieldService,
              translateService: TranslateService,
              fieldsService: FieldsService,
              private dataLoadingService:ClearingFlexTradeDataLoadingService) {
    super(cdref,
      clearingFlexService,
      messageService,
      configService,
      clearingTradeInfoService,
      commonFieldService,
      translateService,
      fieldsService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.dataLoadingService.loadData(this.tracker);

    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.dialog-title');


    this.formConfig = [
      {
        group: 'trades',
        fields: [
          {
            field: 'ownerCode', label: 'Owner', column: 2, type: TYPE.AUTOCOMPLETE,
            options: () => this.dataLoadingService.owners, required: true,
            hidden: () => this.dataLoadingService.owners.length == 1 && this.formRecord.ownerCode == this.dataLoadingService.owners[0].id,
          },
          {
            field: 'trades',
            filter: true,
            column: 12,
            changed: (formRecords: any) => this.refreshInfosFromTrades(formRecords),
            type: TYPE.ADDDELETEFIELD,
            validate: (rec: any) => this.validateTrades(),
            richFieldConfig: {
              canDelete: formRecords => false,
              canAdd: formRecords => false,
              fields: [
                {
                  group: '',
                  fields: [
                    // {field: 'id', column: 2, type: TYPE.HIDDEN},
                    // {field: 'clearingHouse', column: 2, type: TYPE.HIDDEN},
                    {
                      field: 'exchangeCode',
                      icon: (id: string) => {
                        if (this.dataLoadingService.exchanges) {
                          const exchField = this.dataLoadingService.exchanges.find(exchange => exchange.id === id);
                          if (exchField && exchField.value)
                            return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
                        }
                        return 'fas fa-globe-europe';
                      },
                      filter: true,
                      column: 2,
                      type: TYPE.DROPDOWN,
                      options: () => this.dataLoadingService.exchanges,
                    },
                    {field: 'displayReference', column: 2, type: TYPE.TEXT},
                    {field: 'businessDate', column: 2, type: TYPE.DATE},
                    {field: 'contractCode', column: 2, type: TYPE.TEXT},
                    {
                      field: 'side',
                      column: 2,
                      type: TYPE.DROPDOWN,
                      options: () => this.dataLoadingService.sideOptions,
                    },
                    {
                      field: 'type',
                      column: 2,
                      type: TYPE.DROPDOWN,
                      options: () => this.dataLoadingService.tradeTypes,
                    },
                    {
                      field: 'maturity',
                      column: 2,
                      type: TYPE.TEXT,
                      validate: (fTrade: FlexTrade) => !MaturityUtils.isMaturityValid(fTrade.maturity) ? 'Maturity is invalid (ddMMMyyyy,\'W\'WMMMyyyy,MMMyyyy)' : ''
                    },
                    {field: 'volume', column: 2, type: TYPE.INTEGER},
                    {field: 'price', column: 2, type: TYPE.DECIMAL},
                    {field: 'customOrderReference', column: 2, type: TYPE.TEXT},
                  ]
                },
                {
                  group: 'details',
                  collapsed: true,
                  fields: [
                    {field: 'deleted', column: 2, type: TYPE.CHECKBOX},
                    // {field: 'account.name', column: 2, type: TYPE.TEXT},
                    // {field: 'account.type', column: 2, type: TYPE.TEXT},
                    {field: 'account.reference1', column: 2, type: TYPE.TEXT},
                    // {field: 'account.reference2', column: 2, type: TYPE.TEXT},
                    // {field: 'account.reference3', column: 2, type: TYPE.TEXT},
                    // {field: 'avgPrice', column: 2, type: TYPE.DECIMAL},
                    // {field: 'avgPriceGroupId', column: 2, type: TYPE.TEXT},
                    // {field: 'avgPriceResidual', column: 2, type: TYPE.DECIMAL},
                    // {field: 'avgPriceResidualCurrency', column: 2, type: TYPE.TEXT},
                    // {field: 'avgRndPrice', column: 2, type: TYPE.DECIMAL},
                    {field: 'callPut', column: 2, type: TYPE.DROPDOWN, options: () => this.dataLoadingService.callPuts},
                    {field: 'clearingDate', column: 2, type: TYPE.DATE},
                    {field: 'contractUnit', column: 2, type: TYPE.TEXT},
                    {field: 'exchangeReference', column: 2, type: TYPE.TEXT},
                    {field: 'executionDate', column: 2, type: TYPE.DATETIME},
                    {field: 'openClose', column: 2, type: TYPE.DROPDOWN, options: () => this.dataLoadingService.openCloses},
                    {field: 'orderId', column: 2, type: TYPE.TEXT},
                    {field: 'orderReference', column: 2, type: TYPE.TEXT},
                    {field: 'origineTrader', column: 2, type: TYPE.TEXT},
                    {field: 'strike', column: 2, type: TYPE.DECIMAL},
                    {field: 'trader', column: 2, type: TYPE.TEXT},
                    {field: 'tradingEnvironment', column: 2, type: TYPE.TEXT},
                    // {field: 'giveInMessage', column: 2, type: TYPE.TEXT},
                    // {field: 'giveInMessage2', column: 2, type: TYPE.TEXT},
                    // {field: 'giveInMessage3', column: 2, type: TYPE.TEXT},
                    {field: 'giveUpBrokerCode', column: 2, type: TYPE.TEXT},
                    // {field: 'giveUpCommission', column: 2, type: TYPE.TEXT},
                    // {field: 'giveUpMessage', column: 2, type: TYPE.TEXT},
                    // {field: 'giveupAccountType', column: 2, type: TYPE.TEXT},
                    // {field: 'giveupGroupId', column: 2, type: TYPE.TEXT},
                    // {field: 'giveupMessage2', column: 2, type: TYPE.TEXT},
                    // {field: 'giveupMessage3', column: 2, type: TYPE.TEXT}
                  ]
                },
              ]
            }
          }]
      }];
  }

  private validateUploadFile() {
    return this.formRecord && (this.formRecord.file || this.formRecord.trades && this.formRecord.trades.length > 0) ? '' : 'No file selected';
  }

  public validateTrades() {
    if (this.formRecord.trades && this.formRecord.trades.length > 0) {
      for (let trade of this.formRecord.trades) {
        if (!trade.exchangeCode || trade.exchangeCode.length == 0
          || !trade.contractCode || trade.contractCode.length == 0
          || !trade.displayReference || trade.displayReference.length == 0
          || !trade.businessDate
          || !trade.type || trade.type.length == 0
          || !trade.side || trade.side.length == 0
          || !trade.volume || !trade.price) {
          return 'Please fill in all mandatory fields';
        }
      }
    }
    return ''
  }

  save() {
    this.formLoading = true;
    this.markForCheck();
    if (this.formRecord.trades && this.formRecord.trades.length > 0) {

      this.formRecord.trades.forEach(trade => {
        DateFormatPipe.checkDate(trade, 'businessDate');
        DateFormatPipe.checkDate(trade, 'clearingDate');
        DateFormatPipe.checkDate(trade, 'executionDate');
        if (trade.exchangeCode)
          trade.clearingHouse = undefined;
        trade.account = new Account();
        trade.account.name = trade['account.name'];
        trade.account.type = trade['account.type'];
        trade.account.reference1 = trade['account.reference1'];
        trade.account.reference2 = trade['account.reference2'];
        trade.account.reference3 = trade['account.reference3'];
      });
    }
    this.clearingFlexService.tradesRequest(this.formRecord).subscribe(validation => {
      if (validation.success) {
        this.closeDialog();
        this.infoMessage(validation.message);
      } else {
        this.ccFormDialog.ccForm.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
    return;
  }

  closeDialog(): void {
    if (this.ccFormDialog)
      this.ccFormDialog.reloadFieldValueMap();
    this.dialogFormVisible = false;
    this.dialogFormVisibleChange.emit(false);
    this.markForCheck();
  }

  openDialog(trades: Trade[]): void {
    this.refreshInfosFromTrades(trades)
    if (this.ccFormDialog)
      this.ccFormDialog.reloadFieldValueMap();
    this.formRecord = new FlexTradesRequest();
    if (this.dataLoadingService.owners.length > 0 && !this.formRecord.ownerCode) {
      this.formRecord.ownerCode = this.dataLoadingService.owners[0].id;
    }
    trades.forEach(trade => {
      const tradeFlex: FlexTrade = JSON.parse(JSON.stringify(trade));
      tradeFlex.exchangeCode = tradeFlex.exchangeCode.replace(this.configService.flexGwSuffix, '');
      tradeFlex.deleted = false;
      tradeFlex.businessDate = new Date(tradeFlex.businessDate);
      tradeFlex.clearingDate = new Date(tradeFlex.clearingDate);
      tradeFlex.executionDate = new Date(tradeFlex.executionDate);
      if(tradeFlex.account) {
        tradeFlex['account.name'] = trade.account.name;
        tradeFlex['account.type'] = trade.account.type;
        tradeFlex['account.reference1'] = trade.account.reference1;
        tradeFlex['account.reference2'] = trade.account.reference2;
        tradeFlex['account.reference3'] = trade.account.reference3;
      }
      this.formRecord.trades.push(tradeFlex);
    });

    this.dialogFormVisible = true;
    this.dialogFormVisibleChange.emit(true);
    this.markForCheck();
  }

}
